// import { MaterialModule } from './../material/material.module';
import { FullMaterialModule } from 'src/app/material/material-module';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SharedModule } from 'src/app/shared/shared.module';
// import { NgxSpinnerModule } from 'ngx-spinner';
import { MatIconModule } from '@angular/material/icon';

import { MapFieldsComponent } from './map-fields/map-fields.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { UploadRoutingModule } from './upload-routing.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [UploadFileComponent, MapFieldsComponent],
  imports: [
    CommonModule,
    UploadRoutingModule,
    SharedModule,
    FormsModule,
    FullMaterialModule,
    MatSlideToggleModule,
    MatIconModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class UploadModule {}
